var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal modal-vm18 fade",
      class: { show: _vm.shown },
      staticStyle: { display: "block", "padding-left": "0px" },
      style: _vm.shown ? "display: block;" : "display: none;",
      attrs: {
        id: "exampleModalCenter",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "exampleModalLabel",
        "data-backdrop": "static",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered",
          attrs: { role: "document" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "modal-content py-md-5 px-md-4 p-sm-3 p-4 text-center",
            },
            [
              _vm.isVivaincontri
                ? _c("svg-vm18-vivaincontri", { staticClass: "mx-auto" })
                : _c("svg-vm18-skokka", { staticClass: "mx-auto" }),
              _vm._v(" "),
              _c("p", { staticClass: "mt-4 emoji-l" }, [
                _c("b", {
                  domProps: { innerHTML: _vm._s(_vm.i18n.pleaseRead) },
                }),
              ]),
              _vm._v(" "),
              _vm._t("default", function () {
                return [
                  _c("p", {
                    staticClass: "r3 px-md-5 px-sm-1",
                    domProps: { innerHTML: _vm._s(_vm.i18n.eighteenYearOld) },
                  }),
                  _vm._v(" "),
                  _c("hr", { staticClass: "my-1 border-0" }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.i18n.termsAndConditions),
                    },
                  }),
                ]
              }),
              _vm._v(" "),
              _c("p"),
              _vm._v(" "),
              _c("div", { staticClass: "text-center mb-3" }, [
                _c("button", {
                  staticClass: "btn btn-primary w-50 rounded-pill b1",
                  domProps: { innerHTML: _vm._s(_vm.i18n.accept) },
                  on: { click: _vm.accept },
                }),
              ]),
              _vm._v(" "),
              _c("a", {
                staticClass: "text-center no-underline",
                attrs: {
                  href: "https://www.google.com",
                  rel: "noopener nofollow",
                  "data-dismiss": "modal",
                },
                domProps: { innerHTML: _vm._s(_vm.i18n.refuse) },
              }),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }